import React, { useState } from 'react';

/**
 * Reusable avatar display.
 * Shows the user's profile picture if set; falls back to a colored circle
 * with the first letter of their name.
 *
 * Props:
 *   - user:      { name, avatar } — only these two fields are read
 *   - size:      pixel size of the circle (default 38)
 *   - gradient:  CSS background for the letter fallback (default green)
 *   - fontSize:  letter size override (default size/2.5)
 *   - className: extra class to apply on the wrapper
 *   - style:     extra inline styles
 */
const Avatar = ({
  user,
  size = 38,
  gradient = 'linear-gradient(135deg, #209668, #3CCB7F)',
  fontSize,
  className = '',
  style = {},
}) => {
  const [imgFailed, setImgFailed] = useState(false);

  const hasImage = !!user?.avatar && !imgFailed;
  const letter = (user?.name || '?').charAt(0).toUpperCase();

  const baseStyle = {
    width: size,
    height: size,
    borderRadius: '50%',
    overflow: 'hidden',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: gradient,
    color: '#fff',
    fontFamily: 'Nunito, sans-serif',
    fontWeight: 800,
    fontSize: fontSize || Math.round(size / 2.5),
    ...style,
  };

  return (
    <div className={className} style={baseStyle}>
      {hasImage ? (
        <img
          src={user.avatar}
          alt={user?.name || 'User'}
          onError={() => setImgFailed(true)}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      ) : (
        letter
      )}
    </div>
  );
};

export default Avatar;